/**
 * Question Store
 * Manages question-related operations
 */

import { create } from 'zustand';
import { publishJobQuestions, deleteQuestions } from '../services/question.service';
import type { QuestionStore } from '../interfaces/storeInterfaces/questionStore';

export const useQuestionStore = create<QuestionStore>(() => ({
    // Actions
    publishQuestions: async (jobId, questionIds) => {
        try {
            const response = await publishJobQuestions(jobId, questionIds);
            return response;
        } catch (error) {
            console.error(`Failed to publish questions for job ${jobId}:`, error);
            throw error;
        }
    },

    deleteQuestions: async (questionIds) => {
        try {
            const response = await deleteQuestions(questionIds);
            return response;
        } catch (error) {
            console.error(`Failed to delete questions:`, error);
            throw error;
        }
    },
}));

